<template>
  <v-card flat class="mt-4 pa-0">
    <v-card-title class="pl-0">
      <h6>{{ title }}</h6>
    </v-card-title>
    <v-card-subtitle class="pl-0 mt-n6 body-1">
       {{ subtitle }}
    </v-card-subtitle>
    <v-card-text class="pl-0">
      <slot></slot>
    </v-card-text>
  </v-card>      
</template>
    
<script>
//- Rendering and formating helper
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>